namespace $.$$ {

	export class $rise_drag_absolute extends $.$rise_drag_absolute {

		top_px(): string {
			return this.top() + 'px'
		}

		left_px(): string {
			return this.left() + 'px'
		}
		
	}
	
}
